import { useTranslation } from "react-i18next";
import { useRemoteMutation } from "../../useRemote/useRemoteMutation";
import { RemoteApiError } from "../../useRemote/types";

export function useRemoteCreateRoomlayout() {
  const { t } = useTranslation();

  return useRemoteMutation<void, RemoteApiError, FormData>({
    key: ["create-catering-menu"],
    url: `/room-layouts`,
    method: "post",
    snackbarTextOnSuccess: t("Successfully created a roomlayout"),
    snackbarTextOnFail: t(`There was a server error`)
  });
}
